import React from "react";
import { Alert, Form, Icon, InputNumber, Button, Select, Row, Col } from "antd";
import get from "lodash/get";
import { connect } from "react-redux";

import { getEstimateReturn, drugReturnedByPatientRequest } from "../../api/requests";

import classes from "./DrugsEditor.css";
import { logout } from "../../reducers/user/actions";
import { withNamespaces } from "react-i18next";

const { Option } = Select;

class ReturnedByPatientForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      requestResult: {},
      estimateReturn: null,
      estimateReturnError: null,
    };
  }

  componentDidMount() {
    this.getEstimateReturn();
  }

  getEstimateReturn = async () => {
    try {
      const response = await getEstimateReturn(this.props.id);
      this.setState({
        estimateReturn: response.data,
      });
    } catch (e) {
      this.setState({
        estimateReturnError: get(e, 'response.data.error[0]', this.props.i18n.t('Something went wrong')),
      });
    }
  };

  handleSubmit = (e) => {
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true, requestResult: {} });

      if (!err) {
        this.setState({ isLoading: true });

        try {
          const formData = { ...values };

          await drugReturnedByPatientRequest(this.props.id, formData);

          this.setState({
            isLoading: false,
            requestResult: {
              type: "success",
              message: this.props.i18n.t("Success"),
            },
          });

          setTimeout(() => {
            this.props.onSubmit(this.props.id);
          }, 1000);
        } catch (e) {
          if (get(e, "response.status") === 401) {
            this.props.logout();
            return;
          }
          this.setState({
            isLoading: false,
            requestResult: {
              type: "error",
              message: get(e, "response.data.message", this.props.i18n.t("Error")),
            },
          });

          if (get(e, "response.data.errors")) {
            const errors = {};
            Object.keys(get(e, "response.data.errors")).forEach(
              (errorFieldKey) => {
                errors[errorFieldKey] = {
                  value: values[errorFieldKey],
                  errors: get(e, `response.data.errors.${errorFieldKey}`).map(
                    (errorMessage) => new Error(errorMessage)
                  ),
                };
              }
            );
            this.props.form.setFields(errors);
          }
        }
      }
    });
  };

  render() {
    const {
      isLoading,
      requestResult,
      estimateReturn,
      estimateReturnError,
    } = this.state;
    const { getFieldDecorator } = this.props.form;
    const {} = this.props;

    return (
      <div className={classes.wrapper}>
        <Form onSubmit={this.handleSubmit}>
          <h4 className="headline-default">{this.props.i18n.t("Returned by patient")}</h4>

          {!estimateReturnError && !estimateReturn && (
            <Icon type="loading" className={classes.icon} />
          )}

          {estimateReturnError && (
            <Alert message={estimateReturnError} type="warning" />
          )}

          {estimateReturn && (
            <div>
              <div>
                {this.props.i18n.t("Units shipped")}: {get(estimateReturn, "units_shipped_total", "-")}
              </div>
              <div>
                {this.props.i18n.t("Units in package")}: {get(estimateReturn, "units_in_package", "-")}
              </div>
              <div>
                {this.props.i18n.t("Estimated units used")}:{" "}
                {get(estimateReturn, "estimated_used_units", "-")}
              </div>
              <div>
                {this.props.i18n.t("Units already returned")}:{" "}
                {get(
                  estimateReturn,
                  "units_returned_in_different_package",
                  "-"
                )}
              </div>
              <div>
                <hr />
                <b>
                  {this.props.i18n.t("Estimated units to return")}:{" "}
                  {get(estimateReturn, "estimated_returned_units", "-")}
                </b>
              </div>

              <br />
            </div>
          )}

          {(estimateReturnError || estimateReturn) && (
            <div>
              <Row gutter={12}>
                <Col span={12}>
                  <Form.Item label={this.props.i18n.t("Units returned")}>
                    {getFieldDecorator("units_returned", {
                      rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    })(<InputNumber />)}
                  </Form.Item>
                </Col>
              </Row>

              {requestResult.type && (
                <Alert
                  message={requestResult.message}
                  type={requestResult.type}
                  className={classes.submitResult}
                />
              )}

              <div className={classes.actionWrapperDefault}>
                <Form.Item>
                  <Button
                    type="primary"
                    size="large"
                    htmlType="submit"
                    className={classes.submitButton}
                  >
                    {this.props.i18n.t("Save")}
                    {isLoading && <Icon type="loading" />}
                  </Button>
                  &nbsp; &nbsp;
                </Form.Item>

                <Button
                  type="default"
                  size="large"
                  htmlType="button"
                  className={classes.submitButton}
                  onClick={this.props.onCancel}
                >
                  {this.props.i18n.t("Cancel")}
                </Button>
              </div>
            </div>
          )}
        </Form>
      </div>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = { logout };

export default Form.create({ name: "ReturnedByPatientForm" })(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withNamespaces()(ReturnedByPatientForm))
);



// WEBPACK FOOTER //
// ./src/containers/DrugsEditor/ReturnedByPatientForm.js